import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import PhilosophySection from './components/PhilosophySection';
import NewsSection from './components/NewsSection';
import ContactCTA from './components/ContactCTA';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <MissionSection />
      <PhilosophySection />
      <NewsSection />
      <ContactCTA />
      <Footer />
    </main>
  );
}
